import { combineReducers } from "redux-immutable";

import { PERMISSIONS_CONFIG, LOCKS_CONFIG } from "accessConfig";

import app from "./subsystems/app/reducer";
import clients from "./subsystems/clients/reducer";
import { reducer as user } from "@lifepay/redux-subsystem-user";
import { reducerGen as access } from "@lifepay/redux-subsystem-access";

const rootReducer = combineReducers({
  app,
  clients,
  user,
  access: access({
    permissionsConfig: PERMISSIONS_CONFIG,
    locksConfig: LOCKS_CONFIG,
  }),
  // data: combineReducers({
  //   concerts,
  //   artists,
  // })
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/model/reducers.js